import { Box } from '@mui/material';

import { ItemAvailabilityStatus } from 'entities/CatalogItem/lib/itemAvailability';
import { Proposal } from 'entities/Proposal/model/types/ProposalSchema';
import { NoSuppliersMessage } from 'shared/ui/ItemAvailabilityModal';
import { SupplierBadgeWithTooltip } from 'shared/ui/Suppliers/ui/SupplierBadgeWithTooltip';

import { PropertyCatalogItemSupplierStatusIcon } from './PropertyCatalogItemSupplierStatusIcon';

interface PropertyCatalogItemSupplierSlotProps {
    availabilityStatus?: ItemAvailabilityStatus;
    proposals: Proposal[];
    onLearnMore?: () => void;
    showCarriedByLabel?: boolean;
}

export const PropertyCatalogItemSupplierSlot = ({
    availabilityStatus,
    proposals,
    onLearnMore,
    showCarriedByLabel = false,
}: PropertyCatalogItemSupplierSlotProps) => {
    if (availabilityStatus === ItemAvailabilityStatus.NO_SUPPLIERS) {
        return (
            <Box sx={{ mt: '4px' }}>
                <NoSuppliersMessage />
            </Box>
        );
    }

    const isSuppliersNotEnabled =
        availabilityStatus === ItemAvailabilityStatus.SUPPLIERS_NOT_ENABLED;

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'flex-end',
                gap: '6px',
            }}
        >
            <SupplierBadgeWithTooltip
                fullProposals={proposals}
                showCarriedByLabel={showCarriedByLabel}
                dimmed={isSuppliersNotEnabled}
            />
            {isSuppliersNotEnabled && (
                <PropertyCatalogItemSupplierStatusIcon
                    availabilityStatus={availabilityStatus}
                    proposals={proposals}
                    onLearnMore={onLearnMore}
                />
            )}
        </Box>
    );
};
